import {createContext, useContext} from 'react';

/**
 * Пауза уведомлений матча: только на телефоне (уже 1024 px), пока открыт
 * список игроков (выпадает сверху во весь экран) или рынок политик (лист
 * снизу, как раз там, где стоит стек уведомлений). На десктопе паузы нет:
 * поле с открытым списком управляемо, ошибки своих действий должны быть видны.
 * На телефоне предупреждения и ошибки тоже показываются сразу (см. Toast): на паузе
 * стоят только новости о партии
 *
 * @param {{isDesktopLayout: boolean, isPlayersListOpen: boolean, isPolicyMarketOpen: boolean}} layout
 * @returns {boolean}
 */
export const isMatchToastsPaused = ({isDesktopLayout, isPlayersListOpen, isPolicyMarketOpen}) => (
  !isDesktopLayout && (Boolean(isPlayersListOpen) || Boolean(isPolicyMarketOpen))
);

// Флаг раздает стек уведомлений (MatchToastStack); без него — паузы нет
export const MatchToastsPausedContext = createContext(false);

/**
 * Стоят ли уведомления матча на паузе: пока да, их не видно, время не идет и
 * звук не играет
 * @returns {boolean}
 */
export const useMatchToastsPaused = () => useContext(MatchToastsPausedContext);
